//表格公用组件
import React, {Component} from 'react';
import {Tabs, TreeSelect, Input, Table, Divider, Tag, Pagination, Select, Button} from 'antd';
import PropTypes from 'prop-types';
import {Scrollbars} from "react-custom-scrollbars";
import BaseTable from "../../components/baseTable/BaseTable";
import BaseComponent from "../../../base/BaseComponent";
import $Jq from 'jquery';

const {TabPane} = Tabs;
const { Option, OptGroup } = Select;

const {Search} = Input;

class MediaConnectionPage extends BaseComponent {

    constructor(props) {
        super(props);
        this.state = {
        }
    }

    componentWillMount() {
    }

    componentDidMount() {

    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        $Jq('.ant-pagination-options-quick-jumper').find("input").val("");
    }

    onChange = value => {
        this.setState({ value });
    };

    callback=(key) =>{
    };

    render() {
        return (
            <div>
                <div>
                    <div style={{marginLeft:32}}>
                        {/*导航栏*/}
                        {this.renderManuscriptNav()}
                        {/*搜索及按钮区*/}
                        {this.renderSearch()}
                        {/*表格*/}
                        {this.renderTable()}
                    </div>
                    {/*分页栏*/}
                    {this.renderPage()}
                </div>
            </div>
        );
    }

    //导航栏,下拉栏,搜索框
    renderManuscriptNav = () => {
        let {tabChange, navigationBarDate} = this.props;
        return (
            <div>
                {/*导航栏*/}
                <div className={'navigationBarStyle'} style={{marginLeft: -32, paddingTop: 12}}>
                    {
                        (navigationBarDate && navigationBarDate.length)
                            ?
                            (<Tabs defaultActiveKey="1" activeKey={this.props.tabKey} onChange={tabChange}>
                                {
                                    navigationBarDate.map((item, index) => {
                                        return (
                                            <TabPane tab={item.key} key={item.key}/>
                                        )
                                    })
                                }

                            </Tabs>)
                            : null
                    }
                </div>
                <style>
                    {`
                        .navigationBarStyle .ant-tabs-nav{
                             padding-left: 32px;
                       
                         }
                    `}
                </style>
            </div>
        )
    };
    renderSearch = () => {
        let {searchPlaceholder, onChange, WebsiteManagementButton, visitWebsite, addStory, saveSignificance, saveSort, refresh, photos} = this.props;
        return (
            // 新增文章,网络管理,访问网站,搜索框
            <div style={{display: 'flex', justifyContent: 'space-between',}}>
                {/*新增文章按钮*/}
                <div style={{display: 'flex', paddingTop: '25px', marginRight: 16}}>
                    {addStory?
                        <Button type={'primary'} onClick={() => {
                            addStory()
                        }}>新增文章</Button>
                        :null
                    }
                    {photos ? <div style={{}}>
                        {photos}
                    </div> : null}
                    {saveSignificance?
                        <Button style={{marginLeft: 16}} onClick={() => {
                            if(typeof saveSignificance === 'function') saveSignificance()
                        }}>保存重要性</Button>
                        :null
                    }
                    {saveSort?
                        <Button style={{marginLeft: 16}} onClick={() => {
                            if(typeof saveSort === 'function') saveSort()
                        }}>文章排序</Button>
                        :null
                    }
                    {<Button style={{marginLeft: 16}} onClick={() => {
                        if(typeof refresh === 'function') refresh()
                    }}>刷新</Button>}
                </div>
                {/*搜索框*/}
                <div style={{paddingTop: '25px', display: 'flex', paddingRight: '32px'}}>
                    <Button type={'link'} onClick={() => {
                        WebsiteManagementButton()
                    }}>网站管理</Button>
                    <Button type={'link'} onClick={() => {
                        visitWebsite()
                    }}>访问网站</Button>
                    <Search
                        allowClear={true}
                        placeholder={searchPlaceholder}
                        onChange={(e) => {
                            onChange('onChange', e)
                        }}
                        onSearch={(e) => {
                            onChange('onSearch', e)
                        }}
                        style={{width: 272, height: 32, paddingLeft: '24px'}}
                        className={'mediaConnectionPageSearch'}
                    />
                    <style>
                        {
                            `
                            .mediaConnectionPageSearch .ant-input {
                                background-color: #f5f8fc;
                            }
                            `
                        }
                    </style>
                </div>
            </div>
        )
    };

    // 表格
    renderTable = () => {
        let {columns,dataSource,tableHeight}=this.props;
        return (
            <div style={{ marginTop: '24px',marginRight:31,}} className="interval">
                <Scrollbars autoHeight autoHeightMax={tableHeight} autoHide>
                    <BaseTable columns={columns} dataSource={dataSource} />
                </Scrollbars>
            </div>
        )
    };
   // 分页栏
    renderPage=()=>{
        let {onChange,total,params,dataSource}=this.props;
        if(!total) return <div style={{height:81}}></div>;
        if(!(dataSource&&dataSource.length>0) && params.page>1) {
            onChange('page',--params.page);
        }
        return(
            <div style={{
                display: 'flex',
                justifyContent: 'flex-end',
                alignItems: 'center',
                borderTop: '1px solid #eee',
                padding: '24px 32px',}}
            >
                <Pagination
                    size="middle"
                    total={total}
                    showTotal={(total) => `共有${total}条数据`}
                    showSizeChanger
                    showQuickJumper
                    current={params.page}
                    pageSize={params.size}
                    onChange={(page,pageSize)=>{onChange('page',page)}} //页码改变时回调
                    onShowSizeChange={(page,pageSize)=>{onChange('size',pageSize)}} //每页条数改变回调
                />
            </div>
        )
    };
}

MediaConnectionPage.propTypes={
    /**
     * @text 搜索需要传的数据
     * @category object
     */
    params:PropTypes.object,
    /**
     * @text 导航栏内容
     * @category array
     */
    navigationBarDate:PropTypes.array,
    /**
     * @text tab栏切换方法
     * @category array
     */
    tabChange:PropTypes.func,
};

MediaConnectionPage.defaultProps={
    placeholder:'全部稿件',
    searchPlaceholder:'请输入关键字',
};
export default MediaConnectionPage;